export const uppercaseFirstLetter = (str: string): string => {
	if (str.length === 0) {
		return str;
	}

	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const addPrefixToDataParams = ({
	analyticsParam,
	testId,
	prefix,
}: {
	analyticsParam: string;
	testId: string;
	prefix: 'btn' | 'link' | 'modal' | 'form';
}): {
	'data-analytics-param': string;
	'data-test-id': string;
} => {
	return {
		'data-analytics-param': `${prefix}${uppercaseFirstLetter(analyticsParam)}`,
		'data-test-id': `${prefix}${uppercaseFirstLetter(testId)}`,
	};
};

// TODO: add other accents once needed - expansion related
export const replaceAccents = (input: string) => {
	const accentsMap: Record<string, string> = {
		á: 'a',
		č: 'c',
		ď: 'd',
		é: 'e',
		ě: 'e',
		í: 'i',
		ň: 'n',
		ó: 'o',
		ř: 'r',
		š: 's',
		ť: 't',
		ú: 'u',
		ů: 'u',
		ý: 'y',
		ž: 'z',
		Á: 'A',
		Č: 'C',
		Ď: 'D',
		É: 'E',
		Ě: 'E',
		Í: 'I',
		Ň: 'N',
		Ó: 'O',
		Ř: 'R',
		Š: 'S',
		Ť: 'T',
		Ú: 'U',
		Ů: 'U',
		Ý: 'Y',
		Ž: 'Z',
	};

	return input.replace(/[áčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]/g, function (match) {
		return accentsMap[match] || match;
	});
};

export function slugify(input: string): string {
	return replaceAccents(input)
		.replace(/[^a-zA-Z0-9\s]/g, '')
		.toLowerCase()
		.replace(/\s+/g, '-');
}

export function cleanHTML(html: string): string {
	return html.replace(/(<([^>]+)>)/gi, '');
}

export function normalizePath(path: string): string {
	return path.split('#')[0] || '';
}
